import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import TaskResultPage from "./pages/TaskResultPage";
import BusinessProfilePage from "./pages/BusinessProfilePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AdminPage from "./pages/AdminPage";
import EarnPage from "./pages/EarnPage";
import WalletPage from "./pages/WalletPage";
import MyWorkPage from "./pages/MyWorkPage";
import PostTaskPage from "./pages/PostTaskPage";
import PosterWorkspace from "./pages/PosterWorkspace";
import DoerWorkspace from "./pages/DoerWorkspace";
import DoerFeedPage from "./pages/DoerFeedPage";
import DoerProfilePage from "./pages/DoerProfilePage";
import LeaderboardPage from "./pages/LeaderboardPage";
import "./index.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div style={{ minHeight: "100vh", background: "var(--bg-base)" }}>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/search" element={<TaskResultPage />} />
            <Route path="/business/:slug" element={<BusinessProfilePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/earn" element={<EarnPage />} />
            <Route path="/wallet" element={<WalletPage />} />
            <Route path="/my-work" element={<MyWorkPage />} />
            <Route path="/post-task" element={<PostTaskPage />} />
            <Route path="/workspace/:taskId" element={<PosterWorkspace />} />
            <Route path="/doer/feed" element={<DoerFeedPage />} />
            <Route path="/doer/workspace/:taskId" element={<DoerWorkspace />} />
            <Route path="/doer/:doerId" element={<DoerProfilePage />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
          </Routes>
          <footer style={{ borderTop: "1px solid var(--bg-neutral)", padding: "20px 24px", textAlign: "center" }}>
            <p style={{ fontFamily: "'Satoshi', sans-serif", fontSize: "0.72rem", color: "var(--text-muted)", margin: 0, lineHeight: 1.6 }}>
              TIE is operated by and registered under <span style={{ fontWeight: 600, color: "var(--text-secondary)" }}>G.F.T. Investments Private Limited</span>
            </p>
            <p style={{ fontFamily: "'Satoshi', sans-serif", fontSize: "0.65rem", color: "var(--text-muted)", margin: "4px 0 0", opacity: 0.7 }}>
              &copy; {new Date().getFullYear()} TIE — Task Intelligence Engine. All rights reserved.
            </p>
          </footer>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
